<template>
  <div class="dt-field">
    <v-menu
      ref="menu"
      v-model="open"
      offset-y
      nudge-bottom="4"
      min-width="auto"
      :disabled="disabled"
      :close-on-content-click="false"
      content-class="app-menu app-menu--picker"
      role="none"
    >
      <template v-slot:activator="{ on, attrs }">
        <app-button
          kind="field"
          icon="clock"
          chevron
          :disabled="disabled"
          :aria-label="label"
          aria-haspopup="dialog"
          v-bind="attrs"
          v-on="on"
        >{{ label }}</app-button>
      </template>
      <div
        ref="panel"
        class="dt-field__panel"
        role="dialog"
        aria-label="Zeitpunkt wählen"
        tabindex="-1"
        @keydown.tab="trapTab"
      >
        <v-date-picker
          v-model="draftDate"
          no-title
          locale="de"
          color="primary"
          :first-day-of-week="1"
        ></v-date-picker>
        <div class="dt-field__time">
          <label class="app-label" :for="timeId">Uhrzeit</label>
          <app-text-field :id="timeId" v-model="draftTime" type="time" />
        </div>
        <div class="dt-field__actions">
          <app-button class="dt-field__live" @click="live">Live</app-button>
          <app-button @click="open = false">Abbrechen</app-button>
          <app-button :disabled="!canApply" @click="apply">Übernehmen</app-button>
        </div>
      </div>
    </v-menu>
  </div>
</template>

<script>
// Zeitpunkt-Feld (Live-Tracking, Kundenwunsch 13.10.2026 „titel etc nach unserem design anpassen“): Feldknopf mit Uhr
// und ⌄ wie das Zeitraum-Feld (PeriodField), Beschriftung „Zeitpunkt: Live“ bzw. „Zeitpunkt: 13.10.2026, 08:30“.
// Menü mit Datumspicker, Uhrzeit (natives Zeitfeld) und „Live“ | „Abbrechen“ | „Übernehmen“ (alle weiß). Beim Öffnen
// steht der Entwurf auf dem gewählten Zeitpunkt, sonst auf jetzt. Ersetzt die früheren Felder „Datum“ und „Zeit“ mit
// eigenen Menüs und „Löschen“ (Löschen = Live).
// Werte wie auf der Seite: date 'YYYY-MM-DD', time 'HH:mm' (beide null: live). Ereignis apply ({ date, time }) nach
// „Übernehmen“ bzw. mit null/null nach „Live“. Fokusführung aus panelMenu.js wie Zeitraum, Filter und Gruppierung.
import moment from 'moment';
import { raiseMenu } from '@/components/ui/AppSelect.vue';
import panelMenu from '@/components/sales/panelMenu';

export default {
  name: 'DateTimeField',
  mixins: [panelMenu],
  props: {
    date: { type: String, default: null },
    time: { type: String, default: null },
    disabled: { type: Boolean, default: false }
  },
  data() {
    return {
      open: false,
      draftDate: null,
      draftTime: ''
    };
  },
  computed: {
    label() {
      if (!this.date || !this.time) {
        return 'Zeitpunkt: Live';
      }
      return 'Zeitpunkt: ' + moment(this.date).format('DD.MM.YYYY') + ', ' + this.time;
    },
    timeId() {
      return 'dt-field-' + this._uid + '-zeit';
    },
    canApply() {
      return !!this.draftDate && /^\d{2}:\d{2}$/.test(this.draftTime || '');
    }
  },
  watch: {
    open(isOpen) {
      if (isOpen) {
        const now = moment();
        this.draftDate = this.date || now.format('YYYY-MM-DD');
        this.draftTime = this.time || now.format('HH:mm');
        this.focusWhenShown(12);
      }
    }
  },
  mounted() {
    raiseMenu(this.$refs.menu);
  },
  methods: {
    live() {
      this.open = false;
      this.$emit('apply', { date: null, time: null });
    },
    apply() {
      if (!this.canApply) {
        return;
      }
      this.open = false;
      this.$emit('apply', { date: this.draftDate, time: this.draftTime });
    }
  }
};
</script>

<style scoped>
.dt-field {
  display: inline-flex;
  flex: none;
  max-width: 100%;
  min-width: 0;
  vertical-align: middle;
}
.dt-field__panel {
  display: flex;
  flex-direction: column;
}
/* Fokus am Panel selbst nur nach einem Klick auf eine freie Stelle (Esc und Tab wirken weiter): ohne Rahmen */
.dt-field__panel:focus {
  outline: none;
}
.dt-field__time {
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 4px 12px 12px;
}
.dt-field__time .app-label {
  flex: none;
  margin: 0;
}
.dt-field__time .app-field {
  flex: 1 1 auto;
}
.dt-field__actions {
  display: flex;
  justify-content: flex-end;
  gap: 8px;
  padding: 8px 12px 12px;
  border-top: 1px solid var(--line-2);
}
/* „Live“ links, Abbrechen und Übernehmen rechts */
.dt-field__live {
  margin-right: auto;
}
</style>
